// extracted by mini-css-extract-plugin
export var content = "_nk-1";
export var fullScreen = "_nk-0";